export const saveStatus = {
  /** The request has not started yet. It is disabled and waiting for valid props. */
  idle: 'idle',
  /** The request has started and has not resolved. */
  loading: 'loading',
  /** The request has resolved to an error. */
  error: 'error',
  /** The request has resolved successfully. */
  complete: 'complete',
} as const

export type SaveStatus = (typeof saveStatus)[keyof typeof saveStatus]
